// TD1-related code lists for the 856 — TD101 (Packaging Code) and TD106
// (Weight Qualifier).

import type {CodeListEntry} from './types';

export const PACKAGING_CODES: CodeListEntry[] = [
  {code: 'CTN', label: 'Carton'},
  {code: 'PLT', label: 'Pallet'},
  {code: 'BOX', label: 'Box'},
  {code: 'BAG', label: 'Bag'},
  {code: 'BDL', label: 'Bundle'},
  {code: 'CAS', label: 'Case'},
  {code: 'CRT', label: 'Crate'},
  {code: 'DRM', label: 'Drum'},
  {code: 'REL', label: 'Reel'},
  {code: 'ROL', label: 'Roll'},
  {code: 'PCS', label: 'Pieces'},
  {
    code: 'CTN25',
    label: 'Carton, Corrugated or Solid (form + material code 25)',
  },
  {code: 'PLT94', label: 'Pallet, Wood (form + material code 94)'},
];

export const WEIGHT_QUALIFIER_CODES: CodeListEntry[] = [
  {code: 'G', label: 'Gross Weight'},
  {code: 'N', label: 'Actual Net Weight'},
  {code: 'E', label: 'Estimated Net Weight'},
];
